// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DataCacheToolRayType, SelectionModeEnum } from "./DataCacheToolEnums.js";
import { Color, Pen, SolidBrush } from "../../Commons/Graphics.js";
import { ErrorInformationStorage } from "../ErrorInformationStorage.js";
import { Resources } from "../properties/Resources.js";
import { ThemeManager } from "../../Controls/misc/ThemeManager.js";
import { CustomEvent } from "../../Utils/CustomEvents.js";
import { DynProperty, ColorStyleWidth } from "../DynProperty.js";
import { DataCache } from "../DataCache.js";

export var DataCacheTool = function (Id)
{
    this.ID = "DataCacheTool_" + DataCacheTool.toolId;
    DataCacheTool.toolId++;
    this.ToolType = null;
    this.forceUpdateAdditionalPoints = true;
    this.OnUpdate = new CustomEvent();
    //this.ID = Id;
    this.stickTo = 0;
    this.completed = false;
    this.addedPointsNum = -1;
    this.InitBlock();
};
DataCacheTool.toolId = 0;

////#region Properties

////public List<int> AllowedPeriods
////{
////    get { return allowedPeriods; }

////    set
////    {
////        allowedPeriods = value;
////        /// Update periodsOfVisibility...
////    }
////}
////List<int> allowedPeriods;
//		//#region For MQL
//public int WinNum;

//public double[][] originalPoints;
//public List<int> StickToPeriod;

//private string description;
//public virtual string ObjectDescription
//{
//    get { return description; }
//    set { description = value; }
//}

//		//#endregion
//public bool IsBackground;        

DataCacheTool.prototype.InitCompleted = function ()
{
    this.completed = true
    this.InitedPointsNumber = this.PointLevel()
}

Object.defineProperty(DataCacheTool.prototype, 'InitedPointsNumber', {
    get: function () { return this.addedPointsNum; },
    set: function (value) { this.addedPointsNum = value; }
});

Object.defineProperty(DataCacheTool.prototype, 'StickTo', {
    get: function () { return this.stickTo; },
    set: function (value) { this.stickTo = value; }
});

/// <summary>
/// number without AdditionalPoints, only base points
/// </summary>
DataCacheTool.prototype.PointLevel = function ()
{
    return this.Points.length - this.AdditionalPointsCount();
}

DataCacheTool.prototype.CopyPoints = function ()
{
    var copy = new Array(this.Points.length);
    for (var i = 0; i < this.Points.length; i++)
        copy[i] = this.Points[i].slice();
    return copy;
}

/// <summary>
/// Сколько точек (максимально) может быть у тулзы
/// </summary>
DataCacheTool.prototype.MaxPointsCount = function ()
{
    return this.Points.length;
}

// Минимально необходимое число точек для прорисовки тулзы
DataCacheTool.prototype.MinPointsCount = function () { return 1; };

/// <summary>
/// AdditionalPoints число точек для прорисовки тулзы - только для некоторых тулз
/// </summary>
DataCacheTool.prototype.AdditionalPointsCount = function ()
{
    return 0;
}

/// <summary>
/// Добавить новые точки к тулзе
/// </summary>
DataCacheTool.prototype.AddMorePoints = function (count)
{
    if (count <= 0)
        return;

    var newPoints = new Array(this.Points.length + count);
    for (var i = 0; i < this.Points.length; i++)
        newPoints[i] = [this.Points[i][0], this.Points[i][1]];

    for (var i = this.Points.length; i < this.Points.length + count; i++)
        newPoints[i] = [, ];

    this.Points = newPoints;
}

/// <summary>
/// Удалить точки тулзы
/// </summary>
DataCacheTool.prototype.RemoveLastPoints = function (count)
{
    if (count <= 0)
        return;

    var newPoints = new Array(this.Points.length - count);
    for (var i = 0; i < newPoints.length; i++)
        newPoints[i] = [this.Points[i][0], this.Points[i][1]];

    this.Points = newPoints;
}

DataCacheTool.prototype.FireUpdate = function ()
{
    this.OnUpdate.Raise(this);
}
//public Font font;


Object.defineProperty(DataCacheTool.prototype, 'FontColor', {
    get: function () { return this.fontColor; },

    set: function (value)
    {

        if (this.fontColor === value) return;

        this.fontColor = value;
        this.fontBrush = new SolidBrush(this.fontColor);
        this.fontBrushHighlight = new SolidBrush(this.FontColorHighlight);
    }
});

Object.defineProperty(DataCacheTool.prototype, 'FontColorHighlight', {
    get: function ()
    {
        return DataCacheTool.GetLighterColor(this.fontColor);
    }
});

Object.defineProperty(DataCacheTool.prototype, 'FontBrush', {
    get: function () { return this.fontBrush; }
});

Object.defineProperty(DataCacheTool.prototype, 'FontBrushHighlight', {
    get: function () { return this.fontBrushHighlight; }
});

// Цвет тулзы
Object.defineProperty(DataCacheTool.prototype, 'Color', {

    get: function () { return this.color; },

    set: function (value)
    {

        this.color = value;

        this.UpdatePen();
        this.UpdatePenHighlight();
        this.UpdatePenRay();
    }
});

Object.defineProperty(DataCacheTool.prototype, 'ColorHighlight', {
    get: function () { return DataCacheTool.GetLighterColor(this.color); }
});

// Ширина тулзы
Object.defineProperty(DataCacheTool.prototype, 'Width', {
    get: function () { return this.width; },

    set: function (value)
    {
        this.width = value;
        this.UpdatePen();
        this.UpdatePenRay();
        this.UpdatePenHighlight();
        this.penHalo.Width = this.width + 12;
    }
});

//    //public int WinNum = 0;

//    //public long ParentChartID;

Object.defineProperty(DataCacheTool.prototype, 'Style', {
    set: function (value)
    {
        this.style = value;
        this.UpdatePen();
        this.UpdatePenHighlight();
    }
});

Object.defineProperty(DataCacheTool.prototype, 'StyleRay', {
    set: function (value)
    {
        this.styleRay = value;
        this.UpdatePenRay();
    }
});

Object.defineProperty(DataCacheTool.prototype, 'Pen', {
    get: function () { return this.pen; }
});

Object.defineProperty(DataCacheTool.prototype, 'PenRay', {
    get: function () { return this.penRay; }
});

Object.defineProperty(DataCacheTool.prototype, 'PenHighlight', {
    get: function () { return this.penHighlight; }
});

Object.defineProperty(DataCacheTool.prototype, 'PenHalo', {
    get: function () { return this.penHalo; }
});

//static int toolId = 0;
//    /// <summary>
//    /// Уникальный ай-ди-шник
//    /// </summary>
//public readonly string ID;

//public bool forceUpdateAdditionalPoints = true;
////#endregion

DataCacheTool.prototype.InitBlock = function ()
{
    this.pen = new Pen('');
    this.penRay = new Pen('');
    this.penHighlight = new Pen('');
    this.penHalo = new Pen('');
    this.penHalo.LineCap = 'round';

    this.ThemeChanged(true);

    this.Style = Pen.csSimpleChart;
    this.StyleRay = Pen.csShapedChart;
    this.Width = 1;
    this.RayType = DataCacheToolRayType.NoRay;
    this.SelectionMode = SelectionModeEnum.All;

    // TODO. Remove.
    this.StickToPeriod = [];

    this.Localize();

    this.IsBackground = false;
}

DataCacheTool.prototype.ThemeChanged = function (applyToTable)
{
    this.Color = ThemeManager.CurrentTheme.Chart_ToolsDefaultColor;
    this.penHalo.Color = ThemeManager.CurrentTheme.Chart_ToolsSelectionColor;
    this.FontColor = ThemeManager.CurrentTheme.Chart_ToolsDefaultColor;
    this.font = ThemeManager.Fonts.Font_7F_regular.copy();
    this.colorAlpha = 128;
}

DataCacheTool.prototype.Localize = function ()
{
}

/// <summary>
/// 
/// </summary>
DataCacheTool.prototype.UpdatePen = function ()
{
    try
    {
        this.pen.Color = this.color;
        this.pen.Width = this.width;
        Pen.ProcessPen(this.pen, this.style);
    }
    catch (ex) 
    { 
        ErrorInformationStorage.GetException(ex);
    }
}

DataCacheTool.prototype.UpdatePenRay = function ()
{
    try
    {
        this.penRay.Color = this.color;
        this.penRay.Width = this.width;
        Pen.ProcessPen(this.penRay, this.styleRay);
    }
    catch (ex) 
    { 
        ErrorInformationStorage.GetException(ex);
    }
}

DataCacheTool.prototype.UpdatePenHighlight = function ()
{
    try
    {
        this.penHighlight.Color = this.ColorHighlight;
        this.penHighlight.Width = this.width;
        Pen.ProcessPen(this.penHighlight, this.style);
    }
    catch (ex) 
    { 
        ErrorInformationStorage.GetException(ex);
    }
}

DataCacheTool.prototype.InitPoints = function (level, fromCallback = false)
{
    this.Points = new Array(level);
    for (var i = 0; i < this.Points.length; i++)
        this.Points[i] = new Array(2);

    if (!fromCallback)
        this.addedPointsNum = 0     // init started
}

//#region ICaller

DataCacheTool.prototype.Properties = function ()
{
    var prop = null;
    var properties = [];

    prop = new DynProperty("ToolType", this.ToolType, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP);
    properties.push(prop);

    prop = new DynProperty("Stick to", this.stickTo, DynProperty.LINESTICK, DynProperty.HIDDEN_GROUP);
    prop.propertyComment = Resources.getResource("property.chart.stickTo");
    properties.push(prop);

    //prop = new DynProperty("IsBackground", this.IsBackground, DynProperty.BOOLEAN, DynProperty.VISUAL_GROUP);
    //prop.propertyComment = Resources.getResource("property.chart.isBackground");
    //properties.push(prop);

    var csw = new ColorStyleWidth(this.color, this.style, this.width);
    prop = new DynProperty("Line", csw, DynProperty.COLOR_STYLE_WIDTH, DynProperty.VISUAL_GROUP);
    prop.propertyComment = Resources.getResource("property.chart.line");
    properties.push(prop);

    //Hidden prop:
    properties.push(new DynProperty("AssignedSymbol", this.AssignedSymbol, DynProperty.STRING, DynProperty.HIDDEN_GROUP));

    var points = this.Points;
    if (points && this.Instrument)
    {
        properties.push(new DynProperty("Points.Length", points.length, DynProperty.INTEGER, DynProperty.HIDDEN_GROUP));

        var len = points.length - this.AdditionalPointsCount();
        for (var i = 0; i < len; i++)
        {
            properties.push(new DynProperty("X" + i, points[i][0], DynProperty.DATETIME, /*DynProperty.NUMERICAL_PARAMETRS_GROUP*/DynProperty.HIDDEN_GROUP));

            prop = new DynProperty("Y" + i, points[i][1], DynProperty.DOUBLE, /*DynProperty.NUMERICAL_PARAMETRS_GROUP*/DynProperty.HIDDEN_GROUP);
            prop.increment = this.Instrument.MinDelta,
            prop.decimalPlaces = this.Instrument.precision;
            properties.push(prop);
        }
    }

    return properties;
};

DataCacheTool.prototype.callBack = function (properties)
{
    var prop = DynProperty.getPropertyByName(properties, "ToolType");
    if (prop) this.ToolType = prop.value;

    //prop = DynProperty.getPropertyByName(properties, "IsBackground");
    //if (prop) this.IsBackground = prop.value;

    prop = DynProperty.getPropertyByName(properties, "Line");
    if (prop)
    {
        var colorStyleWidth = prop.value;
        this.Color = colorStyleWidth.Color;
        this.Style = colorStyleWidth.Style;
        this.Width = colorStyleWidth.Width;
    }

    prop = DynProperty.getPropertyByName(properties, "Stick to");
    if (prop) this.StickTo = prop.value;

    prop = DynProperty.getPropertyByName(properties, "AssignedSymbol");
    if (prop) 
    {
        this.AssignedSymbol = prop.value;
        this.Instrument = DataCache.getInstrumentByName(this.AssignedSymbol);
    }

    prop = DynProperty.getPropertyByName(properties, "Points.Length");
    if (prop && prop.value !== null && prop.value !== undefined)
    {
        this.InitPoints(prop.value, true);

        var len = this.Points.length - this.AdditionalPointsCount();
        for (var i = 0; i < len; i++)
        {
            var point = this.Points[i];
            prop = DynProperty.getPropertyByName(properties, "X" + i);
            if (prop) point[0] = prop.value;
            prop = DynProperty.getPropertyByName(properties, "Y" + i);
            if (prop) point[1] = prop.value;
        }
    }
};

//#endregion

////#region Misc

DataCacheTool.GetRayType = function (properties)
{
    var RayType = DataCacheToolRayType.NoRay;

    var left = false;
    var right = false;

    var prop = DynProperty.getPropertyByName(properties, "Left ray");
    if (prop) left = prop.value;

    prop = DynProperty.getPropertyByName(properties, "Right ray");
    if (prop) right = prop.value;

    if (left && right)
        RayType = DataCacheToolRayType.DoubleRay;
    else if (left)
        RayType = DataCacheToolRayType.LeftRay;
    else if (right)
        RayType = DataCacheToolRayType.RightRay;
    else
        RayType = DataCacheToolRayType.NoRay;

    return RayType;
};

DataCacheTool.GetLighterColor = function (srcColor)
{
    var correctionFactor = 0.5;

    var channels = Color.getColorChannels(srcColor);

    var a = channels.a;
    var r = channels.r;
    var g = channels.g;
    var b = channels.b;

    var red = (255 - r) * correctionFactor + r;
    var green = (255 - g) * correctionFactor + g;
    var blue = (255 - b) * correctionFactor + b;

    return Color.CreateColor(
        Math.round(red),
        Math.round(green),
        Math.round(blue),
        a);
}

////#endregion

////#region IDefaultSettingsSupportCaller

///// <summary>
///// Параметры для layout
///// </summary>
//public virtual XmlElement XmlSettingsTemplate
//{
//    get
//    {
//        XmlElement xml = XmlSaverLoader.XMLCreator.CreateElement("tool");

//        try
//        {
//            ArrayList properties = Properties;

//            for (int i = 0; i < properties.Count; i++)
//            {
//                DynProperty prop = properties[i] as DynProperty;
//                if (prop != null &&
//                    (prop.Group == DynProperty.VISUAL_GROUP || prop.Group == DynProperty.COLORS_GROUP
//                    || prop.Name == "chart.tools.points" || ((prop.Name.Contains("Level") || prop.Name.Contains("fib.Arc")) && prop.Name.Contains("%"))
//                    || prop.Name == "K" || prop.Name == "Reverse" // FibSpiral
//                    ))
//            {
//                //#19818 п1. Чтоб сохраняло периоды
//                //if (prop.Name == "Stick to period")
//                //  continue;

//                    xml.AppendChild(XmlSaverLoader.XMLCreator.ImportNode((properties[i] as DynProperty).ToXml(), true));
//            }
//    }
//}
//    catch (ex)
//{
//        Utils.log(ex);
//}

//return xml;
//}
//set
//{
//    try
//    {
//        if (value == null)
//            return;

//        ArrayList res = new ArrayList();
//        for (int i = 0; i < value.ChildNodes.Count; i++)
//        {
//            if ((value.ChildNodes[i].NodeType == XmlNodeType.Element) && value.ChildNodes[i].Name == "property")
//                res.Add(new DynProperty(value.ChildNodes[i]));
//        }

//    this.callBack(res);
//}
//    catch ( ex)
//{
//        Utils.log(ex);
//}
//}
//}


///// <summary>
///// 
///// </summary>
//public void SaveSchemeDefault()
//{
//    try
//    {
//        String fileName = defDir + "default." + this.ToString() + "." + Const.tableShemExt;
//        if (!FilesHelper.saveShemToFile(this.XmlSettingsTemplate, fileName))
//        {
//            //не удалось сохранить файл
//            AdvancedMessageBox.ShowMessage(Resources.getResource("workspace.errorSavingFile"),
//                    "Error", System.Windows.Forms.MessageBoxButtons.OK);
//        }
//        else
//        {
//            AdvancedMessageBox.ShowMessage(Resources.getResource("panel.settings.saveDefault"),
//                Resources.getResource("panel.settings.Information"), System.Windows.Forms.MessageBoxButtons.OK);
//        }
//    }
//    catch (Exception ex)
//    {
//        Utils.log(ex);
//    }
//}

/// <summary>
/// 
/// </summary>
DataCacheTool.prototype.LoadSchemeMyProperties = function ()
{
    //try
    //{
    //    //
    //    String fileName = defDir + "default." + this.ToString() + "." + Const.tableShemExt;

    //    // Нет такого файла...
    //    if (!File.Exists(fileName))
    //        return;

    //    System.Xml.XmlElement settings = (XmlElement)FilesHelper.loadShemFromFile("tool", fileName);
    //    if (settings != null)
    //        this.XmlSettingsTemplate = settings;
    //}
    //catch (Exception ex)
    //{
    //    Utils.log(ex);
    //}
}

///// <summary>
///// 
///// </summary>
//public virtual void LoadSchemeDefaultProperties()
//{
//    try
//    {
//        InitBlock();
//    }
//    catch (Exception ex)
//    {
//        Utils.log(ex);
//    }
//}

///// <summary>
///// 
///// </summary>
//protected static string defDir = Environment_Our.GetFolderPath(Environment.SpecialFolder.ApplicationData) + @"\" + Const.defaultDirTrader + @"\";

///// <summary>
///// 
///// </summary>        
//public bool TemplateMode
//{
//    get
//    {
//        return templateMode;
//    }
//    set
//    {
//        templateMode = value;
//    }
//}
//bool templateMode = false;

//#endregion